<script setup lang="ts">
import { lectureService } from '@/api/services/lecture-service'
import BaseHorizontalList from '@/components/base/BaseHorizontalList.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { Lecture } from '@/types/lecture.types'
import { onMounted, ref } from 'vue'
import RecommendContentListItem from './RecommendContentListItem.vue'
const props = defineProps<{
  marginTop?: number
}>()

const recommendContentList = ref<Lecture[]>([])

const isMobile = useIsMobile()

onMounted(async () => {
  const response = await lectureService.getLectures({
    recommended: true,
    size: 6,
  })
  recommendContentList.value = response.data
})
</script>

<template>
  <div v-if="recommendContentList.length > 0">
    <BaseHorizontalList
      v-if="!isMobile"
      title="추천 콘텐츠"
      :showNavigation="true"
      :gap="20"
      :scrollWidth="433"
      :marginTop="props.marginTop"
    >
      <RecommendContentListItem
        v-for="content in recommendContentList"
        :key="content.idx"
        :lecture="content"
      />
    </BaseHorizontalList>
    <div v-else class="recommend-content-list-section">
      <div class="recommend-content-list-section-title title-sm white">추천 콘텐츠</div>
      <div class="recommend-content-list-section-list">
        <RecommendContentListItem
          v-for="content in recommendContentList"
          :key="content.idx"
          :lecture="content"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 1365px) {
  .recommend-content-list-section {
    display: flex;
    flex-direction: column;
    margin-top: 32px;
  }

  .recommend-content-list-section-title {
    padding: 0 20px;
    margin-bottom: 12px;
  }

  .recommend-content-list-section-list {
    display: flex;
    flex-direction: column;
    gap: 28px;
  }
}
</style>
